import { render, staticRenderFns } from "./ProductGalleries.vue?vue&type=template&id=dcd2113c&scoped=true&"
import script from "./ProductGalleries.vue?vue&type=script&lang=js&"
export * from "./ProductGalleries.vue?vue&type=script&lang=js&"
import style0 from "./ProductGalleries.vue?vue&type=style&index=0&id=dcd2113c&prod&scoped=true&lang=css&"
import style1 from "./ProductGalleries.vue?vue&type=style&index=1&id=dcd2113c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd2113c",
  null
  
)

export default component.exports